import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaOverviewMovementPage } from './plaza-overview-movement';

@NgModule({
  declarations: [
    PlazaOverviewMovementPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaOverviewMovementPage),
    TranslateModule.forChild()
  ],
})
export class PlazaOverviewMovementPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-overview-movement/plaza-overview-movement.module.ts